// extracted by mini-css-extract-plugin
module.exports = {"navigationBtn":"MarketOverview_navigationBtn__1R1NM"};